import { createContext } from 'react';

export const AppSettingsContext = createContext(
  {
    "locale": "da"
    // TODO set visibility of footer, nav, lang etc.
  }
);